import { FilterListSMSIcon } from '@rsos/assets/icons';
import { Button, Text } from '@rsos/base-components';
import styles from './TT911PendingChatCard.module.css';

const TT911_SESSION_PENDING_MESSAGE =
  'A Text-to-911 location has been received. The message is being processed — please wait before starting a chat.';

/**
 * Shown while a call is tagged TT911 (e.g. ALI class_of_service_category
 * 'Text') but no INdigital/TCAPI text session exists yet.
 */
const TT911PendingChatCard = () => (
  <div className={styles.container} data-name="tt911-pending-chat-card">
    <Text
      data-name="tt911-pending-message"
      color="secondaryText"
      fontWeight="regular"
      size="xsmall"
    >
      {TT911_SESSION_PENDING_MESSAGE}
    </Text>
    <div className={styles.startChatRow}>
      <div className={styles.startChatButtonWrapper}>
        <Button
          dataName="tt911-pending-start-chat-button"
          disabled
          title={TT911_SESSION_PENDING_MESSAGE}
          btnType="tertiary"
          noMargin
          size="med"
          grow
          gap="4px"
        >
          <FilterListSMSIcon width={12} height={12} />
          Start Chat
        </Button>
      </div>
    </div>
  </div>
);

export default TT911PendingChatCard;
